module.exports = __webpack_public_path__ + "img/clics.489bc8d5.svg";